import React from "react";

const SecondBanner = ({
  isActive,
  text,
  backgroundColor,
  textColor,
}) => {
  if (isActive !== "1" || !text) {
    return null;
  }

  const style = {};
  if (backgroundColor) {
    style.backgroundColor = backgroundColor;
  }
  if (textColor) {
    style.color = textColor;
  }

  return (
    <div className="second-banner" style={style}>
      <div className="second-banner__content">
        <p>{text}</p>
      </div>
    </div>
  );
};

export default SecondBanner;
